import { render } from "./ServicesTemplate.vue?vue&type=template&id=19ae1ece"
import script from "./ServicesTemplate.vue?vue&type=script&lang=js"
export * from "./ServicesTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__